"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expressions = void 0;
exports.executeExpression = executeExpression;
exports.executeExpressions = executeExpressions;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const to_enums_1 = require("../../shared/to-enums");
const stringify_value_1 = require("../utils/stringify-value");
const execute_syntax_1 = require("./execute-syntax");
const iterable_count_1 = require("./iterable-count");
const term_validation_1 = require("./term-validation");
// The Expressions.execute function won't internally call iteself to handle
// multiple instances of an iterable. This is the job of the executeExpression
// Using a method for execute so we can spyOn it in tests.
class Expressions {
    static execute(state, exp, origin) {
        // This is the only expression on the actual iterable.
        if (exp.type === "count") {
            (0, iterable_count_1.handleCount)(state, exp);
            return;
        }
        if (exp.iterableName &&
            origin &&
            !state.iterables[exp.iterableName].instances[origin?.iterableIndex]) {
            console.log({
                exp,
                origin,
                iterables: state.iterables,
            });
            throw new Error("Instance for iterable not found");
        }
        const iterableIndex = origin?.iterableIndex;
        if (exp.type === "validation") {
            (0, term_validation_1.handleValidation)(state, exp, iterableIndex);
            return;
        }
        const { termName, iterableName } = exp;
        const term = getTerm(state, termName, iterableName, iterableIndex);
        if (exp.type === "basic" && exp.name === "required" && !term.isRelevant) {
            term.isRequired = false;
            return;
        }
        const context = (0, pi_syntax_tools_1.getContext)({
            ...state,
            this: iterableName && iterableIndex !== undefined
                ? {
                    index: iterableIndex,
                    position: iterableIndex + 1,
                    term,
                    iterable: state.iterables[iterableName],
                    terms: state.iterables[iterableName].instances[iterableIndex].terms,
                }
                : {
                    term,
                },
        });
        if (exp.type === "enums-relevant") {
            handleEnumsRelevant(state, exp, context, iterableIndex);
            return;
        }
        const output = (0, execute_syntax_1.tryExecSyntaxForExpression)(exp.syntax, context, exp, iterableIndex);
        if (exp.type === "enums-fn") {
            const dynamicEnums = (0, to_enums_1.toEnums)(output);
            if (!term.enums) {
                term.enums = [];
            }
            term.enums.length = exp.initialEnumsLength + dynamicEnums.length;
            for (let x = exp.initialEnumsLength; x < term.enums.length; x += 1) {
                const { label, value } = dynamicEnums[x - exp.initialEnumsLength];
                const isRelevant = !term.isRelevant || !!label;
                if (!term.enums[x]) {
                    term.enums[x] = {
                        label,
                        value,
                        isRelevant,
                    };
                    continue;
                }
                term.enums[x].label = label;
                term.enums[x].value = value;
                term.enums[x].isRelevant = isRelevant;
            }
            return;
        }
        switch (exp.name) {
            case "calculate":
                term.value = (0, stringify_value_1.stringifyValue)(output, term);
                if (state.phase === "INITIAL") {
                    term.ready = term.value;
                }
                break;
            case "label":
                term.label = String(output);
                break;
            case "relevant":
                term.isRelevant = Boolean(output);
                break;
            case "required":
                term.isRequired = Boolean(output);
                break;
            case "readonly":
                term.isReadonly = Boolean(output);
                break;
            default:
                throw new Error(`Unknown type: ${exp.name}`);
        }
    }
}
exports.Expressions = Expressions;
function executeExpression(state, exp, origin) {
    // If these expresions didn't originate from an iterable index then we need
    // to run the expression on each index of the iterable.
    if (exp.iterableName &&
        exp.type !== "count" &&
        // This expression depends on more than just the current index of this iterable
        ((origin?.iterableName &&
            exp.iterableInstanceDeps[origin.iterableName] === "all") ||
            // The origin does not match the current iterable
            exp.iterableName !== origin?.iterableName)) {
        for (let i = 0; i < state.iterables[exp.iterableName].count; i += 1) {
            Expressions.execute(state, exp, {
                iterableName: exp.iterableName,
                iterableIndex: i,
            });
        }
        return;
    }
    Expressions.execute(state, exp, origin);
}
function executeExpressions(state, expressions, origin) {
    if (!expressions) {
        return;
    }
    for (const exp of expressions) {
        executeExpression(state, exp, origin);
    }
}
function getTerm(state, termName, iterableName, iterableIndex) {
    if (iterableName && iterableIndex !== undefined) {
        return state.iterables[iterableName].instances[iterableIndex].terms[termName];
    }
    return state.terms[termName];
}
function handleEnumsRelevant(state, exp, context, iterableIndex) {
    const { termName, iterableName } = exp;
    const term = getTerm(state, termName, iterableName, iterableIndex);
    for (const relExp of exp.items) {
        if (!term.enums || relExp.enumIndex >= term.enums.length) {
            throw new Error(`Enum index ${relExp.enumIndex} does not exist on term ${termName}`);
        }
        const output = (0, execute_syntax_1.tryExecSyntaxForExpression)(relExp.syntax, context, exp, iterableIndex);
        term.enums[relExp.enumIndex].isRelevant = Boolean(output);
    }
}
//# sourceMappingURL=execute-expressions.js.map